export const META_PIXEL_ID = '1035214262882099'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

export function initMetaPixel(pixelId: string = META_PIXEL_ID) {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod.apply(fbq, args)
    } else {
      fbq!.queue!.push(args)
    }
  } as Window['fbq']

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq!.push = fbq
  fbq!.loaded = true
  fbq!.version = '2.0'
  fbq!.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  img.alt = ''
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  window.fbq?.('track', event, params)
}
